import React from "react";
import SocReasonsIcon from "../Icons/SocReasonsIcon";

interface IAppointmentTypeSelectionCard {
    icon?:JSX.Element;
    cardTitle: string;
    isSelected?: boolean;
    onClick?:(cardTitle: string) => void;
    hasSocData?: boolean;
    petName: string;
}

const ReasonTypeSelectionCard = ({
  icon,
  cardTitle,
  isSelected=false,
  hasSocData=false,
  petName,
  onClick,
}: IAppointmentTypeSelectionCard) => {
  const handleCardClick = ()=>{
    onClick && onClick(cardTitle);
  };

  return (
    <div
      className={`relative border border-bg-taupe-50 bg-white cursor-pointer rounded-lg flex flex-col
        gap-3 items-center flex-1 p-9
    ${isSelected ?
      "!bg-gv-yellow-light border-gv-yellow" : "hover:bg-gv-yellow-light hover:border-gv-yellow"}`}
      onClick={handleCardClick}
    >
      {hasSocData &&
      <div className={`text-xs font-semibold absolute top-0 bg-gv-yellow-light
      w-full rounded-t-lg p-1.5 flex gap-0.5  ${isSelected? "bg-white":"bg-gv-gold-1"}`}>
        <div className="flex justify-center">
          <div className={`flex items-center justify-center
           rounded-full p-0.5 h-fit w-fit  ${isSelected && "bg-gv-gold-1"}`}>
            <SocReasonsIcon />
          </div>
        </div>
        <div className="text-center">{`${petName} is due for a Semi-Annual Exam`}</div>
      </div>
      }
      {icon &&
      <div className={`flex items-center justify-center ${isSelected ?
        "bg-gv-gold-1" : "bg-taupe-6"} rounded-full p-2 h-fit mt-3`}>
        {icon}
      </div>
      }
      <div className="px-4 text-sm font-semibold text-center">
        {cardTitle}
      </div>
    </div>
  );
};

export default ReasonTypeSelectionCard;
